<template>
  <v-card class="adminPanel" flat elevation="0">
    <v-row class="pa-6 pb-0 flex-grow-0" no-gutters>
      <v-col cols="12" md="3">
        <v-card-title class="administrationHeader">
          {{ $t('app.routes.administration') }}
        </v-card-title>
      </v-col>
      <v-col cols="12" md="6" align="center">
        <div class="tabs">
          <v-tabs align-tabs="center" v-model="tab" class="tabStructure" color="primary">
            <v-tab :value="'accounts'" data-cy="accountTable">
              {{ $t('administrationPanel.accounts') }}
            </v-tab>
            <v-tab :value="'services'" data-cy="servicesTable">
              {{ $t('administrationPanel.services') }}
            </v-tab>
          </v-tabs>
        </div>
      </v-col>
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <v-tabs-window v-model="tab">
      <v-window-item value="accounts">
        <AccountTable />
      </v-window-item>
      <v-window-item value="services">
        <ThirdPartyTable />
        <TsiTable />
      </v-window-item>
    </v-tabs-window>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AccountTable from '@/components/adminPanel/accountTable.vue'
import ThirdPartyTable from '@/components/adminPanel/thirdPartyTable.vue'
import TsiTable from '@/components/adminPanel/tsiTable.vue'

export default defineComponent({
  name: 'AdministrationPanel',
  data() {
    return {
      tab: 'accounts' as string
    }
  },
  components: {
    AccountTable,
    ThirdPartyTable,
    TsiTable
  }
})
</script>

<style lang="scss" scoped>
.adminPanel {
  display: flex;
  flex-direction: column;
  min-height: calc(100dvh - var(--v-layout-top));
  background-color: transparent;

  .administrationHeader {
    font-weight: 300;
    font-size: 24px;
    padding: 0;
  }

  .v-tabs-window {
    flex-grow: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;

    :deep(.v-window__container) {
      flex-grow: 1;
      min-height: 0;
    }

    .v-window-item {
      flex-grow: 1;
      min-height: 0;
      height: 100%;
    }
  }
}
</style>
